import { useEffect, useMemo, useRef } from 'react'

/** Returns a debounced version of `fn`. Latest args win. */
export function useDebouncedCallback<A extends unknown[]>(
  fn: (...args: A) => void,
  ms: number,
): (...args: A) => void {
  const fnRef = useRef(fn)
  useEffect(() => {
    fnRef.current = fn
  }, [fn])

  const timer = useRef<ReturnType<typeof setTimeout> | undefined>(undefined)
  useEffect(() => () => clearTimeout(timer.current), [])

  return useMemo(() => {
    return (...args: A) => {
      clearTimeout(timer.current)
      timer.current = setTimeout(() => fnRef.current(...args), ms)
    }
  }, [ms])
}
